"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "resizeobserver",
      rawName: "v-resizeobserver",
      value: _vm.onListResize,
      expression: "onListResize"
    }],
    key: `messagelist-${_vm.buffer.name}`,
    ref: "scroller",
    staticClass: "app-messagelist",
    class: {
      'app-messagelist--smoothscroll': _vm.smooth_scroll,
      'app-messagelist--showtyping': _vm.buffer.setting('share_typing')
    },
    style: {
      fontSize: _vm.messageFontSize
    },
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.onListClick.apply(null, arguments);
      },
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    directives: [{
      name: "resizeobserver",
      rawName: "v-resizeobserver",
      value: _vm.onListResize,
      expression: "onListResize"
    }]
  }, [_vm.shouldShowChathistoryTools && !_vm.buffer.flag('is_requesting_chathistory') ? _c('div', {
    staticClass: "app-messagelist-scrollback"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function ($event) {
        return _vm.buffer.requestScrollback();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('messages_load')) + " ")])]) : _vm._e(), _c('remove-before-update', [_vm._l(_vm.filteredMessagesGroupedDay, function (day) {
    return [_vm.filteredMessagesGroupedDay.length > 1 && day.messages.length > 0 ? _c('div', {
      key: `msgdatemarker${day.dayNum}`,
      staticClass: "app-messagelist-seperator"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDayLabel(day.messages[0].time)))])]) : _vm._e(), _c('remove-before-update', {
      key: day.dayNum
    }, [_vm._l(day.messages, function (message) {
      return [_c('div', {
        key: `msg${message.id}_${message.instance_num}`,
        class: ['app-messagelist-item', _vm.selectedMessages[message.id] ? 'app-messagelist-item--selected' : '']
      }, [message.render() && message.template && message.template.$el && _vm.isTemplateVue(message.template) ? _c('div', {
        directives: [{
          name: "rawElement",
          rawName: "v-rawElement",
          value: message.template.$el,
          expression: "message.template.$el"
        }]
      }) : message.render() && message.template ? _c(message.template, _vm._b({
        tag: "component",
        attrs: {
          "buffer": _vm.buffer,
          "message": message,
          "idx": _vm.filteredMessages.indexOf(message),
          "ml": _vm.thisMl
        }
      }, 'component', message.templateProps, false)) : _vm.listType === 'modern' ? _c('message-list-message-modern', {
        attrs: {
          "message": message,
          "idx": _vm.filteredMessages.indexOf(message),
          "ml": _vm.thisMl
        }
      }) : _vm.listType === 'inline' ? _c('message-list-message-inline', {
        attrs: {
          "message": message,
          "idx": _vm.filteredMessages.indexOf(message),
          "ml": _vm.thisMl
        }
      }) : _vm.listType === 'compact' ? _c('message-list-message-compact', {
        attrs: {
          "message": message,
          "idx": _vm.filteredMessages.indexOf(message),
          "ml": _vm.thisMl
        }
      }) : _vm._e()], 1)];
    })], 2)];
  })], 2), _c('transition', {
    attrs: {
      "name": "app-messagelist-joinloadertrans"
    }
  }, [_vm.shouldShowJoiningLoader ? _c('div', {
    staticClass: "app-messagelist-joinloader"
  }, [_c('LoadingAnimation')], 1) : _vm._e()]), _vm.shouldRequestChannelKey ? _c('buffer-key', {
    attrs: {
      "buffer": _vm.buffer,
      "network": _vm.buffer.getNetwork()
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "app-messagelist-jumpbottom-anchor"
  }, [_c('transition', {
    attrs: {
      "name": "app-messagelist-jump-trans"
    }
  }, [_vm.isScrolledUp ? _c('button', {
    staticClass: "app-messagelist-jumpbottom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.jumpToBottom.apply(null, arguments);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 3v8M4 8l4 4 4-4",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _c('span', [_vm._v("Voir les derniers messages")])]) : _vm._e()])], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];